const e={channelId:"magazine_ecomm",searchDefault:{pageId:"search_results",placementId:"search_results",showcaseId:"search_results"},originBob:"bob"};export{e as default};
